//Google Analytics のイベント関連
$(document).ready(function() { 
  'use strict';


  function initEvents( target ) {
    //console.log('initEvents called.');
    initGaEvent( target );
    initCvEvent( target );
  }

  //クリックイベントを初期化
  function initGaEvent( targetNode ) { 

    //初期化の対象範囲を決める
    var $eventNodes;
    if ( targetNode ) {
      $eventNodes = $(targetNode).find('.ga-event');
    } else {
      $eventNodes = $('.ga-event');
    }

    //対象範囲にクリックイベントを設定
    $eventNodes.one( 'click',function() {
      var $this = $(this);
      var type = $this.data('type') || 'default';
      var category = $this.data('category') || $this.data('event-category');
      var action = $this.data('action') || $this.data('event-action') || 'click';
      var label = $this.data('label') || $this.data('event-label');
      var value = $this.data('value') || $this.data('event-value') || 1;
      var position = $this.data('position');
      var options = {
        nonInteraction: true,
      };

      recordClickLog(type,category,label,position);
    });
  }


  //コンバージョンイベントの初期化
  function initCvEvent( targetNode ) { 

    //初期化の対象範囲を決める
    var $eventNodes;
    if ( targetNode ) {
      $eventNodes = $(targetNode).find('.cv-event');
    } else {
      $eventNodes = $('.cv-event');
    }

    //対象範囲にクリックイベントを設定
    $eventNodes.one( 'click',function() {
      var $this = $(this);

      var data = {};
      data.action = 'moko_record_cv_log';
      data.cv_category = $this.data('cv_category');
      data.cv_type = $this.data('cv_type') ;
      data.cv_label = $this.data('cv_label');
      data.cv_value = $this.data('cv_value') ;
      data.cv_position = $this.data('cv_position') ;
      data.cv_id = $this.data('cv_id') ;
      data.cv_url = $this.data('cv_url') ;
      data.page_url = location.href.replace(location.hash,"");

      $.ajax({
        type : 'POST',
        url: moko.ajaxurl,
        //dataType : 'json',
        dataType: 'text',
        //contentType : 'application/json',
        timeout: 3000,
        cache : false,
        data: data,
      }).
      always(function() {
        //
      }).
      fail(function(xhr, status, error) {
        console.log('action failed: ' + status + ' ' + xhr.status + ' ' + xhr.statusText);
      }).
      done(function(data) {
        console.log('action done.');
      });


    });
  }


  //スクロールイベント
  function initScrollEvent() { 
    var window_height = $(window).height();
    var $scroll_event_elements = $('.ga-event-scroll');
    $(window).on('scroll', function() {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      scrollTop += window_height;
      var elem_position = $scroll_event_elements.position();
      $scroll_event_elements.each( function() {
        var $this = $(this);
        //console.log( this.event_seneded);
        if ( !this.event_seneded ) {
          var top = $this.position().top;
          //  console.log( 'event scroll', top, scrollTop );
          if ( top < scrollTop ) { 
            var type = $this.data('type') || 'impression';
            var category = $this.data('category');
            var action = $this.data('action')||'scroll';
            var label = $this.data('label');
            var value = $this.data('value') || 1;

            //console.log('event','scrolled');
            recordImpLog( type, category, action);

            this.event_seneded = true;
          }
        }
      });
    });
  }

  //インプレッション
  function recordImpLog(type,category,label) {
      var data = {};
      data.action = 'moko_record_imp_log';
      data.imp_type = type;
      data.imp_category = category;
      data.imp_label = label;
      data.imp_url = location.href.replace(location.hash,"");

      $.ajax({
        type : 'POST',
        url: moko.ajaxurl,
        //dataType : 'json',
        dataType: 'text',
        //contentType : 'application/json',
        timeout: 3000,
        cache : false,
        data: data,
      }).
      always(function() {
        //
      }).
      fail(function(xhr, status, error) {
        console.log('imp failed: ' + status + ' ' + xhr.status + ' ' + xhr.statusText);
      }).
      done(function(data) {
        console.log('imp done.',data);
      });
  }

  //クリックログ
  function recordClickLog(type,category,label,position) {
      var data = {};
      data.action = 'moko_record_click_log';
      data.click_type = type;
      data.click_category = category;
      data.click_label = label;
      data.click_position = position;
      data.click_url = location.href.replace(location.hash,"");

      $.ajax({
        type : 'POST',
        url: moko.ajaxurl,
        //dataType : 'json',
        dataType: 'text',
        //contentType : 'application/json',
        timeout: 3000,
        cache : false,
        data: data,
      }).
      always(function() {
        //
      }).
      fail(function(xhr, status, error) {
        console.log('click failed: ' + status + ' ' + xhr.status + ' ' + xhr.statusText);
      }).
      done(function(data) {
        console.log('click done.',data);
      });
  }




  /**
   * 初期化処理
   **/
  initEvents();
  initScrollEvent();


  //外部へ開放するイベント
  /**
   * イベントの初期化:
   * DOMを再構築したときに呼び出す
   **/
  moko.initEvents = initEvents;


});
